import React from 'react';
import PropTypes from 'prop-types';

import {Box} from 'views/components';
import {BrokenImage as BrokenImageIcon} from 'views/icons';

import {ImageDisplay, FileDisplay} from './DisplayComponents';

import backend from 'utils/backend';

const SecureFile = (props) => {
  const [downloadedSrc, setDownloadedSrc] = React.useState(null);
  const [downloadFailed, setDownloadFailed] = React.useState(false);

  const file = props.file;
  const sx = props.sx;

  const {type, src} = file;

  React.useEffect(() => {
    setDownloadedSrc(null);
    setDownloadFailed(false);
  }, [src]);

  const getDownloadedSrc = async () => {
    if (downloadedSrc) {
      return downloadedSrc;
    } else {
      try {
        const file = await backend.fileStorage.getSecureFile(src);
        const fileSrc = URL.createObjectURL(file);
        setDownloadedSrc(fileSrc);
        return fileSrc;
      } catch {
        setDownloadFailed(true);
        return null;
      }
    }
  };

  const DisplayComponent = type.match(/image\/.*/) ? ImageDisplay : FileDisplay;

  if (file.unavailable || downloadFailed) {
    return (
      <Box
        height="100%"
        sx={{
          alignItems: 'center',
          color: 'text.disabled',
          display: 'flex',
          justifyContent: 'center',
          minWidth: 'inherit',
          maxWidth: 'inherit',
          ...sx,
        }}
      >
        <BrokenImageIcon sx={{fontSize: 48}} />
      </Box>
    );
  }

  return (
    <Box
      height={'100%'}
      sx={{
        'minWidth': 'inherit',
        'maxWidth': 'inherit',
        ...sx,
      }}
    >
      <DisplayComponent
        getDownloadedSrc={getDownloadedSrc}
      />
    </Box>
  );
};

SecureFile.propTypes = {
  file: PropTypes.shape({
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
    unavailable: PropTypes.bool,
  }).isRequired,
  sx: PropTypes.object,
};

export default React.memo(SecureFile);

